import React from "react";
import loadable from "@loadable/component";
import SwitchTab from "../../components/Reusable/SwitchTab";
const StockLedgerDetailComponent = loadable(
  () => import("../../components/InventoryReport/StockLedgerDetail")
);

const StockLedgerDetail = () => {
  const tabs = [
    {
      id: "stock-ledger-normal",
      label: "Normal",
      href: "/accounting/stock-ledger-normal",
    },
    {
      id: "stock-ledger-detail",
      label: "Detail",
      href: "/accounting/stock-ledger-detail",
    },
  ];
  return (
    <>
      <SwitchTab tabs={tabs} />
      <StockLedgerDetailComponent />
    </>
  );
};

export default StockLedgerDetail;
